import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async (_, filter) => {
  try {
    const { data } = await axios.get('wallet-extract', {
      params: filter,
    })

    if (data) {
      return data
    }

    return null
  } catch (error) {
    return error
  }
}

export const exportSynthetic = async (_, filter = {}) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get('wallet-extract/synthetic-export', {
      params: filter,
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: response.headers?.['content-type'] || 'application/octet-stream',
    })

    let fileName = 'campanhas-mes.xlsx'
    const contentDisposition = response.headers?.['content-disposition']
    if (contentDisposition) {
      const match =
        contentDisposition.match(/filename\*\=UTF-8''([^;]+)/i) ||
        contentDisposition.match(/filename="([^"]+)"/i) ||
        contentDisposition.match(/filename=([^;]+)/i)

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim())
      }
    }

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }, 100)

    Vue.prototype.$notify('Relatório de campanhas baixado com sucesso', 'success')
    return true
  } catch (err) {
    Vue.prototype.$notify('Erro ao baixar relatório de campanhas', 'error')
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.post('wallet-maintenance', body)

    if (status) {
      return status
    }

    return null
  } catch (error) {
    return error
  } finally {
    Vue.prototype.$loading(false)
  }
}
